export const normalizeWhitespaceAndTrim = (text: string): string => {
  return text.replace(/[^\S\n]+/g, " ").trim();
};
